import { endpoints, baseurl } from "../Utils/Constants";

export const getReportAutomations = async (token) => {
    try {
        const response = await fetch(`${baseurl}${endpoints.GET_REPORT_AUTOMATIONS}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        });
        const result = await response.json();
        return result;
    } catch (error) {
        console.error("Error fetching report automations:", error);
        throw error;
    }
};

export const getReportLogins = async (automation, token) => {
    try {
        const response = await fetch(`${baseurl}${endpoints.GET_REPORT_LOGINS}${encodeURIComponent(automation)}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        });
        const result = await response.json();
        return result;
    } catch (error) {
        console.error("Error fetching report logins:", error);
        throw error;
    }
};

export const getReportRuns = async (token) => {
    try {
        const response = await fetch(`${baseurl}${endpoints.GET_REPORT_RUNS}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        });
        const result = await response.json();
        return result;
    } catch (error) {
        console.error("Error fetching report runs:", error);
        throw error;
    }
};

export const runReport = async (data, token) => {
    try {
        const response = await fetch(`${baseurl}${endpoints.RUN_REPORT}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(data),
        });
        const result = await response.json();
        return result;
    } catch (error) {
        console.error("Error starting report run:", error);
        throw error;
    }
};
